import { render } from "./modelBindCommon.vue?vue&type=template&id=03af9c84&scoped=true"
import script from "./modelBindCommon.vue?vue&type=script&lang=js"
export * from "./modelBindCommon.vue?vue&type=script&lang=js"

import "./modelBindCommon.vue?vue&type=style&index=0&id=03af9c84&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03af9c84"]])

export default __exports__